import './polyfills';

import './../sass/main.scss';

const ITEM_CLASS = 'notice';
const DELAY = 5000;
const container = document.createElement('div');
container.className = 'notices';
container.addEventListener('click', (e) => {
    if (e.target.classList.contains(ITEM_CLASS)) {
        hide(e.target);
    } else {
        let closestEl = e.target.closest('.' + ITEM_CLASS);
        if (closestEl) {
            hide(closestEl);
        }

    }
});

const element = document.createElement('div');
element.className = ITEM_CLASS;

const show = (msg = '', type = '') => {
    if (!document.body.contains(container)) {
        document.body.appendChild(container);
    }
    let appended = element.cloneNode();
    if (type) {
        appended.classList.add(`${ITEM_CLASS}--${type}`);
    }
    appended.innerHTML = msg;
    container.appendChild(appended);
    setTimeout(() => {
        appended.style.opacity = '1';
    });
    setTimeout(() => {
        hide(appended);
    }, DELAY);
}

const hide = (el) => {
    el.style.opacity = '0';
    setTimeout(() => {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        }
        if (container.parentNode && container.children.length === 0) {
            container.parentNode.removeChild(container);
        }

    }, 400)

}

const success = (msg = '') => {
    show(msg, 'success');
}
const error = (msg = '') => {
    show(msg, 'error');
}
const notice = (msg = '') => {
    show(msg)
}

export {success, error, notice}